var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.08 -6.599)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.08 6.599)",
    fill: "none",
    stroke: "#e52431",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 30,
    rx: 29.5,
    ry: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 30,
    rx: 28,
    ry: 28.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.113,4.847,21.768,11.5,7.317,25.953l-5.933.655A1.248,1.248,0,0,1,.007,25.23l.66-5.937L15.113,4.847Zm10.771-.991L22.76.732a2.5,2.5,0,0,0-3.53,0l-2.94,2.94,6.655,6.655,2.94-2.94a2.5,2.5,0,0,0,0-3.53Z",
    transform: "translate(16.143 23.421)",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.702928515a5ecaeb65fc23e52fb0e8e9.svg";
export { ForwardRef as ReactComponent };